module.exports = __webpack_public_path__ + "static/img/gong1.f9e73f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/gong1.png
// module id = qv3g
// module chunks = 44